var ImageAPI = require('../../../api').Image;

module.exports = function ($scope, file, options, $timeout) {
  $scope.file = file;
  $scope.crop = {};
  $scope.options = options || {};
  $scope.size = options.size || '334x220';

  $scope.back = function ($event) {
    $event.preventDefault();
    $scope.closeThisDialog({ action: 'back' });
    $scope.back = function ($event) {
      $event.preventDefault();
      $scope.closeThisDialog({ action: 'back' });
    }
  }

  $scope.save = function ($event) {
    $event.preventDefault();

    // do cropping magic
    // replace file with new file
    $scope.cropping = true;

    ImageAPI.Crop({ file: file, crop: $scope.crop }).then(function (result) {
      $scope.cropping = false;
      $scope.closeThisDialog({ action: 'save', file: [ result.highQualityImage, result.lowQualityImage ] });
    })
  }
}
